// @flow
import ReactDOM from 'react-dom';
import BrowserApp from './BrowserApp';
import * as serviceWorker from './serviceWorker';
import * as Sentry from '@sentry/react';
import {BrowserTracing} from '@sentry/tracing';
import environment from './environment';

import './index.css';

if (environment.sentryDSN)
  Sentry.init({
    dsn: environment.sentryDSN,
    integrations: [new BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    normalizeDepth: 10,
    environment: environment.environment,
    release: `qempo-shop-backoffice-webapp@${environment.version}`,
    ignoreErrors: ['ResizeObserver loop limit exceeded'],
  });

console.log(
  '%c•%c•%c• %cTienda%cDA',
  'color: #FFC840; font-weight: bold;',
  'color: #FF3C66; font-weight: bold;',
  'color: #7F53E3; font-weight: bold;',
  'color: black; font-weight: bold;',
  'color: #7F53E3; font-weight: bold;'
);
ReactDOM.render(BrowserApp, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
